"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
var Form_1 = __importDefault(require("../components/Form"));
var constants_1 = require("../data/constants");
var FormUtility = /** @class */ (function () {
    function FormUtility() {
    }
    FormUtility.getFormObject = function (formElement, formErrorMessages) {
        var inputs = formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        var objectShape = {};
        var _loop_1 = function (i) {
            var element = inputs[i];
            var type = element.type;
            var identifier = element.dataset.formField;
            var required = element.dataset.required;
            var id = element.id;
            var strRegExp = element.dataset.regEx;
            var errorMessage = element.dataset.errorMessage;
            var dataFormField = element.dataset.formField;
            var min = void 0;
            var max = void 0;
            var regExp = void 0;
            var newRegExp;
            if (strRegExp) {
                regExp = strRegExp.replace(/\//g, '');
                newRegExp = new RegExp(regExp);
            }
            if (['date'].includes(type)) {
                var date = inputs[i];
                if (date.min) {
                    min = new Date(date.min);
                }
                if (date.max) {
                    max = new Date(date.max);
                }
            }
            if (required) {
                if (['text', 'textarea', 'select-one'].includes(type)) {
                    if (id.includes('zip') && newRegExp) {
                        objectShape[identifier] = yup.string()
                            .matches(newRegExp, errorMessage ? errorMessage : formErrorMessages.zip)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else {
                        objectShape[identifier] = yup.string()
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['tel'].includes(type)) {
                    if (newRegExp) {
                        objectShape[identifier] = yup.string()
                            .matches(newRegExp, errorMessage ? errorMessage : formErrorMessages.tel)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else {
                        objectShape[identifier] = yup.string()
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['date'].includes(type)) {
                    if (min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else if (!min) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else if (!max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['email'].includes(type)) {
                    objectShape[identifier] = yup.string()
                        .email(errorMessage ? errorMessage : formErrorMessages.email)
                        .required(errorMessage ? errorMessage : formErrorMessages.required);
                }
                if (['checkbox', 'radio'].includes(type)) {
                    objectShape[identifier] = yup.boolean()
                        .default(false)
                        .oneOf([true], errorMessage ? errorMessage : formErrorMessages.required)
                        .required(errorMessage ? errorMessage : formErrorMessages.required);
                }
            }
            else {
                if (['text', 'textarea', 'select-one'].includes(type)) {
                    if (id.includes('zip') && newRegExp) {
                        objectShape[identifier] = yup.string()
                            .test('is-empty', function () { return errorMessage ? errorMessage : formErrorMessages.zip; }, function (value) { return !!(value === '' || (value === null || value === void 0 ? void 0 : value.match(newRegExp))); });
                    }
                    else if (dataFormField.startsWith('honeypot')) {
                        objectShape[identifier] = yup.string()
                            .test('is-empty', 'not empty', function (value) { return value === ''; });
                    }
                    else {
                        objectShape[identifier] = yup.string();
                    }
                }
                if (['tel'].includes(type)) {
                    if (newRegExp && element.value !== '') {
                        objectShape[identifier] = yup.string()
                            .test('is-empty', function () { return errorMessage ? errorMessage : formErrorMessages.tel; }, function (value) { return !!(value === '' || (value === null || value === void 0 ? void 0 : value.match(newRegExp))); });
                    }
                    else {
                        objectShape[identifier] = yup.string();
                    }
                }
                if (['date'].includes(type)) {
                    if (min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax);
                    }
                    else if (!min) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax);
                    }
                    else if (!max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin);
                    }
                }
                if (['email'].includes(type)) {
                    objectShape[identifier] = yup.string()
                        .email(errorMessage ? errorMessage : formErrorMessages.email);
                }
                if (['checkbox', 'radio'].includes(type)) {
                    objectShape[identifier] = yup.boolean()
                        .default(false);
                }
            }
        };
        for (var i = 0; i < inputs.length; i++) {
            _loop_1(i);
        }
        return yup.object().shape(objectShape);
    };
    FormUtility.getFormValues = function (formElement) {
        var inputs = formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        var formValues = {};
        for (var i = 0; i < inputs.length; i++) {
            var element = inputs[i];
            var type = element.type;
            var identifier = element.dataset.formField;
            if (['text', 'textarea', 'email', 'tel', 'date', 'select-one'].includes(type)) {
                formValues[identifier] = Form_1.default.getValue(formElement, identifier);
            }
            if (['checkbox', 'radio'].includes(type)) {
                formValues[identifier] = Form_1.default.getChecked(formElement, identifier);
            }
        }
        return formValues;
    };
    return FormUtility;
}());
exports.default = FormUtility;
